var gql = require("graphql-tag");

const MUTATE_SITECONFIG_COUNTER = gql`
    mutation {
        counterIncrement {
            order_counter
        }
    }
`;

export default MUTATE_SITECONFIG_COUNTER;
